var _excluded = ["src", "alt", "fill", "stroke", "icon", "children"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { BuildingFilled } from '@gympass/yoga-icons';
import { string, func, checkPropTypes } from 'prop-types';
import Box from '../../Box';
import Icon from '../../Icon';
var Image = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n"])));

var Content = function Content(_ref) {
  var icon = _ref.icon,
      alt = _ref.alt,
      src = _ref.src,
      fill = _ref.fill,
      content = _ref.content,
      stroke = _ref.stroke;

  if (src) {
    return /*#__PURE__*/React.createElement(Image, {
      src: src,
      alt: alt
    });
  }

  if (content) {
    return content;
  }

  return /*#__PURE__*/React.createElement(Icon, {
    as: icon,
    width: "50%",
    height: "50%",
    fill: fill,
    stroke: stroke
  });
};
/**
 * The Avatar component is used to display the image.
 * It has two shapes: default and circle
 */


var Avatar = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
      alt = _ref2.alt,
      fill = _ref2.fill,
      stroke = _ref2.stroke,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? BuildingFilled : _ref2$icon,
      children = _ref2.children,
      otherProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    bgColor: "elements.selectionAndIcons",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    borderRadius: "small",
    elevation: "small",
    overflow: "hidden",
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(Content, {
    icon: icon,
    src: src,
    fill: fill,
    stroke: stroke,
    content: children,
    alt: alt
  }));
});
Content.propTypes = _extends({
  src: string,
  icon: func,
  fill: string,
  alt: string
}, Box.propTypes);
Content.defaultProps = {
  src: undefined,
  fill: 'white',
  alt: undefined,
  icon: undefined
};
Avatar.propTypes = _extends({
  src: string,

  /**  Required if src is true */
  alt: function alt(props, propName, componentName) {
    var src = props.src;

    if (src) {
      var _checkPropTypes;

      checkPropTypes((_checkPropTypes = {}, _checkPropTypes[propName] = string.isRequired, _checkPropTypes), props, 'prop', componentName);
    }

    return null;
  },

  /** Used when src is missing */
  icon: function icon(props, propName, componentName) {
    var _checkPropTypes2;

    var src = props.src,
        iconProp = props[propName];

    if (src && iconProp) {
      return new Error("You should provide a src or " + propName + " prop, not both, in '" + componentName + "'.");
    }

    checkPropTypes((_checkPropTypes2 = {}, _checkPropTypes2[propName] = func, _checkPropTypes2), props, 'prop', componentName);
    return null;
  },
  fill: string,
  stroke: string
}, Box.propTypes);
Avatar.defaultProps = _extends({
  src: undefined,
  alt: undefined,
  icon: undefined,
  fill: 'white',
  stroke: undefined
}, Box.defaultProps);
Avatar.displayName = 'Avatar';
export default Avatar;